module.exports = "https://trybtryb-legacy.web.app/img/link.18285061.svg";